<template lang="pug">
  tr.row
    JobTableFavoriteStar(:job="job", @update="update", :updateFavorForIndex="updateFavorForIndex")
    JobTableMark(:job="job", @update="update", :updateMarkForIndex="updateMarkForIndex")
    td.col.check
      label.checkbox
        input(
          type="checkbox",
          :value="job.id",
          :checked='checked',
          :disabled="isGlobalLocked",
          @click="check($event, job.id)"
        )
    td.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      template(v-if="v.posting")
        span.view(v-if="job.posting")
          | 掲載中
        span.view_end(v-else)
          | 終了
      template(v-else-if="v.key == 'company_name'")
        span.only-sp(v-if="v.spLabel") {{ v.label }}
        a(v-if="v.modal", @click="display") {{ job['company_name'] }}
        span(v-else) {{ job['company_name'] }}
        a(v-if="exclusionCompanyName"
         :class="job.hidden ? 'hidden on' : 'hidden'"
         @click="hideCompany(job.hidden, job.id, job['company_name'])")
          i.fa.fa-eye-slash
      template(v-else-if="v.jobId")
        a(:href="job['media_url']" target="_blank" rel="noopener noreferrer") {{ job[v.key] }}
      template(v-else-if="v.key == 'campany_tel'")
        span {{job['display_company_tel']}}
      template(v-else-if="v.url")
        a(:href="job[v.key]" target="_blank" rel="noopener noreferrer") {{ job[v.key] }}
      template(v-else-if="v.articlePlan")
        span(v-if="job[v.key]") {{ job[v.key].toLocaleString("ja-JP") }}万円
        span(v-if="job[v.key] === 0") 0円
        span(v-else) &nbsp;
      template(v-else-if="v.multiple")
        span(v-for="c in job[v.key]")
          | {{ c }}
          br
      template(v-else)
        span.only-sp(v-if="v.spLabel") {{ v.label }}
        a(v-if="v.modal", @click="display") {{ job[v.key] }}
        span(v-else) {{ job[v.key] }}
    td.col
      span.new(v-if="job.is_new") NEW
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import JobTableFavoriteStar from './JobTableFavoriteStar'
  import JobTableMark from './JobTableMark'

  export default {
    components: { JobTableFavoriteStar, JobTableMark },
    props: ['job', 'modal', 'checkedIds', 'updateFavorForIndex', 'updateMarkForIndex', 'exclusionCompanyName'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      ...mapState({
        columns: state => state.jobTableConfiguration.columns,
        displayedColumns: state => state.jobTableConfiguration.displayedColumns,
      }),
      checked () {
        return this.checkedIds.has(this.job.id)
      },
    },
    methods: {
      ...mapMutations('job', ['clearDetail']),
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      hideCompany (hidden, id, name) {
        if (hidden) {
          this.$router.push({ name: 'ExclusionCompanyName' })
        } else {
          const companyName = name.replace(/&amp;/g, '&')
          this.$emit('hideCompany', { id, companyName })
        }
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.job.id })
      },
      update () {
        this.clearDetail()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobTableRow.vue